import React from 'react';
import { CustomInput, Card } from 'reactstrap';
import { Field, useField } from 'react-final-form';

import { required } from 'utils/formValidators';
import { ReactSelectAdapter } from './FormFields/libraryFields';

const RECURRING_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

const RECURRING_FREQUENCY_OPTIONS = [
  RECURRING_FREQUENCY.DAILY,
  RECURRING_FREQUENCY.WEEKLY,
  RECURRING_FREQUENCY.MONTHLY,
];

const RecurringFrequency = () => {
  return (
    <React.Fragment>
      <label htmlFor="recurring_frequency">Frequency</label>
      <Field id="recurring_frequency" name="recurring_frequency">
        {({ input }) => (
          <ul className="frequency-options">
            {RECURRING_FREQUENCY_OPTIONS.map(option => {
              const isActive = option === input.value;
              const activeStyle = isActive ? 'active' : '';

              return (
                <li
                  role="none"
                  className={`frequency-option-btn text-capitalize my-2 ${activeStyle}`}
                  onClick={() => input.onChange(option)}
                >
                  {option}
                </li>
              );
            })}
          </ul>
        )}
      </Field>
    </React.Fragment>
  );
};

const RecurringPeriodicity = () => {
  const recurringFrequency = useField('recurring_frequency');
  const recurringPeriodicity = useField('max_recurring_allowed');
  const recurringFrequencyValue = recurringFrequency.input.value;
  const recurringPeriodicityValue = recurringPeriodicity.input.value.value;

  let periodicity = 7;
  switch (recurringFrequencyValue) {
    case RECURRING_FREQUENCY.DAILY:
      periodicity = 1;
      if (recurringPeriodicityValue > 1) {
        recurringPeriodicity.input.onChange({ label: 1, value: 1 });
      }
      break;
    case RECURRING_FREQUENCY.WEEKLY:
      periodicity = 7;
      if (recurringPeriodicityValue > 7) {
        recurringPeriodicity.input.onChange({
          label: 1,
          value: 1,
        });
      }
      break;
    case RECURRING_FREQUENCY.MONTHLY:
      periodicity = 30;
      break;
    default:
      break;
  }
  const options = Array(periodicity)
    .fill()
    .map((value, index) => ({
      label: index + 1,
      value: index + 1,
    }));

  return (
    <React.Fragment>
      <label htmlFor="periodicity">Periodicity</label>
      <div className="row align-items-center">
        <div className="col-md-2">
          <Field
            name="max_recurring_allowed"
            placeholder="Custom Time"
            id="periodicity"
            component={ReactSelectAdapter}
            options={options}
            clearable={false}
            validate={required}
          />
        </div>
        <div className="col-md-3 p-md-0 text-bold">
          times per {getFrequencyValue(recurringFrequencyValue)}
        </div>
      </div>
      <hr />
      <div className="frequency-summary">
        {`User can take same survey ${recurringPeriodicityValue || 0} ${
          recurringPeriodicityValue > 1 ? 'times' : 'time'
        } per 
        ${getFrequencyValue(recurringFrequencyValue)}`}
        .
      </div>
    </React.Fragment>
  );
};

const getFrequencyValue = recurringFrequencyValue => {
  if (recurringFrequencyValue === RECURRING_FREQUENCY.DAILY) return 'day';
  return recurringFrequencyValue.replace('ly', '');
};

const RecurringConfiguration = ({ conditionalFieldName }) => {
  const field = useField(conditionalFieldName);
  const isRecurring = field.input.value;

  if (!isRecurring) return null;

  return (
    <Field
      name="recurring_frequency"
      type="checkbox"
      render={({ input }) => {
        return (
          <div className="p-3">
            <RecurringFrequency />
            <hr />
            <RecurringPeriodicity />
          </div>
        );
      }}
    />
  );
};

const RecurringCustomSurvey = () => {
  return (
    <Card className="styled-box-shadow mt-3 mb-3 p-3">
      <Field
        name="is_survey_recurring"
        type="checkbox"
        render={({ input }) => {
          return (
            <div className="custom-survey-field mt-2 pl-3 " fluid>
              <CustomInput id={input.name} {...input} />
              <label htmlFor={input.name} className="cursor-pointer">
                Allow my guests to take this survey more than once
              </label>
            </div>
          );
        }}
      />
      <RecurringConfiguration conditionalFieldName="is_survey_recurring" />
    </Card>
  );
};

export default RecurringCustomSurvey;



// WEBPACK FOOTER //
// ./src/components/customSurvey/recurringCustomSurvey.js